import type { LucideIcon } from "lucide-react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogAction,
  AlertDialogMedia,
} from "./ui/alert-dialog";

interface StatusDialogProps {
  icon: LucideIcon;
  iconClassName?: string;
  mediaClassName?: string;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}

export function StatusDialog({
  icon: Icon,
  iconClassName,
  mediaClassName,
  title,
  description,
  actionLabel,
  onAction,
}: StatusDialogProps) {
  return (
    <AlertDialog open>
      <AlertDialogContent
        size="sm"
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
      >
        <AlertDialogHeader>
          <AlertDialogMedia className={mediaClassName}>
            <Icon className={iconClassName} />
          </AlertDialogMedia>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        {actionLabel && (
          <AlertDialogFooter className="sm:justify-center">
            <AlertDialogAction className="w-full" onClick={onAction}>
              {actionLabel}
            </AlertDialogAction>
          </AlertDialogFooter>
        )}
      </AlertDialogContent>
    </AlertDialog>
  );
}
